import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 53.5 36.4",
  width: "53.5",
  height: "57.537",
  "xml:space": "preserve"
}
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  props: {
  color: {
    type: String,
    default: '#D4D4D4',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M12.7,21c3.7,0,6.5-5.1,6.5-8.5c0,0,0,0,0,0c0-1.7-0.7-3.3-1.9-4.6C16.1,6.7,14.5,6,12.7,6c0,0,0,0,0,0   c-3.6,0-6.5,2.9-6.5,6.5C6.3,15.9,9,21,12.7,21z M12.7,7.5C12.7,7.5,12.7,7.5,12.7,7.5c1.3,0,2.6,0.5,3.5,1.4   c0.9,0.9,1.5,2.2,1.5,3.5v0c0,2.7-2.3,7-5,7s-5-4.3-5-7C7.8,9.7,10,7.5,12.7,7.5z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_2),
      _createElementVNode("path", {
        d: "M40.7,21c3.8,0,6.5-5.1,6.5-8.5c0,0,0,0,0,0c0-1.7-0.7-3.3-1.9-4.6C44.1,6.7,42.5,6,40.7,6c0,0,0,0,0,0   c-3.6,0-6.5,2.9-6.5,6.5C34.3,15.9,37,21,40.7,21z M40.7,7.5C40.7,7.5,40.7,7.5,40.7,7.5c1.3,0,2.6,0.5,3.5,1.4   c0.9,0.9,1.5,2.2,1.5,3.5v0c0,2.7-2.3,7-5,7s-5-4.3-5-7C35.8,9.7,38,7.5,40.7,7.5z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M53.1,23.7c-2.4-1.4-5-2.3-7.7-2.7c-0.3-0.1-0.7,0.1-0.8,0.4c-0.7,1.6-2.2,3.5-3.8,3.5c-1.7,0-3.1-1.9-3.8-3.5   c-0.1-0.3-0.5-0.5-0.8-0.4c-1.4,0.2-2.8,0.6-4.2,1.1v0c0.8-1.5,1.3-3.2,1.3-4.6c0,0,0,0,0,0c0-1.7-0.7-3.3-1.9-4.6   c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0,0,0c1.4-1.8,2.2-4.2,2.2-6.1c0,0,0,0,0,0c0-1.7-0.7-3.3-1.9-4.6C30.1,0.7,28.5,0,26.7,0   c0,0,0,0,0,0c-1.7,0-3.3,0.7-4.6,1.9c-1.2,1.2-1.9,2.8-1.9,4.6c0,1.9,0.8,4.3,2.2,6.1c-1.4,1.2-2.2,2.9-2.2,4.9   c0,1.4,0.5,3.1,1.3,4.6c0,0,0,0,0,0c-1.3-0.5-2.7-0.9-4.2-1.1c-0.3-0.1-0.7,0.1-0.8,0.4c-0.7,1.6-2.2,3.5-3.8,3.5   c-1.7,0-3.1-1.9-3.8-3.5c-0.1-0.3-0.5-0.5-0.8-0.4c-2.7,0.4-5.3,1.4-7.7,2.7C0.1,23.8,0,24.1,0,24.4v3.8c0,0.3,0.2,0.6,0.6,0.7   c0.6,0.2,1.3,0.4,2,0.6c2.9,0.8,6.4,1.9,10.2,1.9c0.4,0,0.8,0,1.3,0v1.8c0,0.3,0.2,0.6,0.6,0.7c0.6,0.2,1.3,0.4,2,0.6   c2.9,0.8,6.4,1.9,10.2,1.9c3.8,0,7.3-1.1,10.2-1.9c0.7-0.2,1.4-0.4,2-0.6c0.3-0.1,0.6-0.4,0.6-0.7v-1.8c0.4,0,0.8,0,1.2,0   c3.8,0,7.3-1.1,10.2-1.9c0.7-0.2,1.4-0.4,2-0.6c0.3-0.1,0.6-0.4,0.6-0.7v-3.8C53.5,24.1,53.4,23.8,53.1,23.7z M21.8,6.5   c0-2.7,2.2-5,5-5c0,0,0,0,0,0c1.3,0,2.6,0.5,3.5,1.4c0.9,0.9,1.5,2.2,1.5,3.5v0c0,1.6-0.8,3.7-2,5.3c-0.9-0.5-1.9-0.7-3-0.7   c0,0,0,0,0,0c-1.1,0-2.1,0.3-3,0.7c0,0,0,0,0,0C22.6,10.2,21.8,8.1,21.8,6.5z M26.7,12.5C26.7,12.5,26.7,12.5,26.7,12.5   c1.3,0,2.6,0.5,3.5,1.4c0.9,0.9,1.5,2.2,1.5,3.5v0c0,2.7-2.3,7-5,7s-5-4.3-5-7C21.8,14.7,24,12.5,26.7,12.5z M31.6,22.7   C31.6,22.7,31.6,22.7,31.6,22.7C31.6,22.7,31.6,22.7,31.6,22.7z M31.1,23.3C31.1,23.3,31.1,23.3,31.1,23.3   C31.1,23.3,31.1,23.3,31.1,23.3z M28.6,28.9c0.1,0,0.1,0,0.2,0.1c0.2-0.2,0.4-0.4,0.6-0.6c-0.7,0.8-1.6,1.5-2.6,1.5   c-1,0-1.9-0.6-2.6-1.5c0.2,0.2,0.4,0.4,0.6,0.6c0.1,0,0.2,0,0.2-0.1c0.3-0.1,0.6-0.4,0.6-0.7v-2.4c0.4,0.1,0.8,0.2,1.2,0.2   c0.4,0,0.9-0.1,1.3-0.2v2.4C28,28.5,28.2,28.8,28.6,28.9z M14.4,28.7c-0.2,0.1-0.4,0.4-0.4,0.7v0.5c-0.4,0-0.8,0-1.3,0   c-3.6,0-6.9-1-9.8-1.8c-0.5-0.2-1-0.3-1.5-0.4v-2.8c2-1.1,4.1-1.8,6.3-2.2c1,1.9,2.8,3.8,4.9,3.8c2.2,0,3.9-1.9,4.9-3.8   c2,0.4,3.8,1,5.6,1.9l0,0c0.2,0.2,0.4,0.4,0.7,0.6v2.6c-0.1,0-0.2,0.1-0.4,0.1c0.2,0.2,0.3,0.5,0.5,0.7c-0.5-0.6-0.9-1.3-1.2-2   c-0.1-0.3-0.5-0.5-0.8-0.4C19.4,26.4,16.8,27.3,14.4,28.7z M21.9,22.7C21.9,22.7,21.9,22.7,21.9,22.7   C21.9,22.7,21.9,22.7,21.9,22.7z M22.3,23.3C22.3,23.3,22.3,23.3,22.3,23.3C22.3,23.3,22.3,23.3,22.3,23.3z M38,32.6   c-0.5,0.1-1,0.3-1.5,0.4c-2.9,0.9-6.2,1.8-9.8,1.8c-3.6,0-6.9-1-9.8-1.8c-0.5-0.2-1-0.3-1.5-0.4v-2.8c2-1.1,4.1-1.8,6.3-2.2   c1,1.9,2.8,3.8,4.9,3.8c2.2,0,3.9-1.9,4.9-3.8c2.2,0.4,4.3,1.2,6.3,2.3V32.6z M29.3,28.4c0.2-0.2,0.3-0.4,0.5-0.7   C29.7,27.9,29.5,28.1,29.3,28.4z M52,27.6c-0.5,0.1-1,0.3-1.5,0.4c-2.9,0.9-6.2,1.8-9.8,1.8c-0.4,0-0.8,0-1.2,0v-0.5   c0-0.3-0.1-0.5-0.4-0.7c-2.4-1.4-5-2.3-7.7-2.7c-0.3-0.1-0.7,0.1-0.8,0.4c-0.2,0.4-0.4,0.9-0.7,1.3c-0.1,0-0.2-0.1-0.3-0.1V25   c0.2-0.2,0.5-0.4,0.7-0.6c1.8-0.9,3.7-1.5,5.6-1.9c1,1.9,2.8,3.8,4.9,3.8c2.2,0,3.9-1.9,4.9-3.8c2.2,0.4,4.3,1.2,6.3,2.3V27.6z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_4)
    ])
  ]))
}
}

})